
import { createStore, combineReducers } from 'redux';
import rootReducer from './rootReducer';
const store = createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
export const Store = {
    store
}